// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--vspMS","title":"a10a3f92e9--title--NdkJl","agent-name":"a10a3f92e9--agent-name--r0wFg","proofs":"a10a3f92e9--proofs--IdWlU"};